var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "social-container" }, [
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("wechat")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#6ba2d6" } },
          [
            _c("i", {
              staticClass: "iconfont icon-weixin",
              attrs: { "icon-class": "wechat" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("login.wechat"))),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("tencent")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#8dc349" } },
          [
            _c("i", {
              staticClass: "iconfont icon-qq",
              attrs: { "icon-class": "qq" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("login.qq")))]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }